import AbsCaptcha from "./AbsCaptcha";
import type { CaptchaType } from "./Captcha";
import type {CaptchaData} from './AbsCaptcha'
export default class WaveCaptcah extends AbsCaptcha {

    constructor(protected ElWrapperId: string, protected captchaType: CaptchaType, protected clientKey: string, protected CAPTCHA_INFO_API_DOMAIN: string) {
      super();
    }

    async init() {
      this.#injectWaveCaptchaCSS();
      this.#injectWaveCaptchaHtml();

      return this;
    }

    refresh() {
      // 리프레쉬 할게 뭐가 있지?
    }

    /**
     * 정확한 의미로는 invisible 형태 외에
     * 1) checkbox 형태의 recaptcha또는
     * 2) 유저가 텍스트를 입력하는 wave 캡차는
     * 캡챠를 프로그래밍적으로 실행할 필요가 없다.
     * 하지만 recaptcha의 경우 checkbox 는 사용하지 않는게 현재의 내부 방침이며
     * wave 캡챠의 경우 메서드 통일로 사용자가 사용하기 쉽게(구글일때만 execute를 실행하기 위해 분기 태우는 행위 x) 하기 위해 만듬
     * 즉, recaptcha invisible 의 사용법과 같이
     * 서버에 보낼대 excute 실행후, 유저가 입력한 값을 가져 온다.
     */
    execute() {
      return new Promise((res, rej) => {
        res(this.captchaData);
      });
    }

    get captchaData(): CaptchaData {
      return {
        type: this.captchaType,
        response: (document.getElementById('capt') as HTMLInputElement).value,
        clientKey: this.clientKey,
      };
    }

    #injectWaveCaptchaCSS() {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.media = 'screen';
      link.href = 'https://wstatic-cdn.plaync.com/gnb/openapi/wavecaptcha.css?v=201901311434';
      document.head.appendChild(link);
    }

    #injectWaveCaptchaHtml() {
      const ElIDCaptchaImg = 'captcha_img';
      const ElIDWaveCacptchaKey = 'waveCaptchaKey';
      const ElIDWaveCaptchaRetryUrl = 'waveCaptchaRetryUrl';
      const ElIDResetCaptcha = 'reset_captcha';

      const captchaImageUrl = `${this.CAPTCHA_INFO_API_DOMAIN}/captcha/image?type=${this.captchaType}&clientKey=${this.clientKey}`;

      // Reload captcha function
      const refreshCaptcha = function () {
        const url = `${captchaImageUrl}&v=${new Date().getTime()}`;
        document.getElementById(ElIDCaptchaImg)!.setAttribute('src', url);
      };

      const captchaDiv = document.getElementById(this.ElWrapperId) as HTMLElement;
      captchaDiv.innerHTML = `
          <div class="input-captcha text-captcha">
            <div class="wrap-text-captcha">
              <div class="captcha-img"><img src="${captchaImageUrl}" id="${ElIDCaptchaImg}" alt="" /></div>
              <div class="captcha-text">
                <div class="input-text"><input type="text" id="capt" name="capt" autocomplete="off" placeholder="請輸入驗證碼" /></div>
                <a id="${ElIDResetCaptcha}" class="reload" href="javascript:void(0);">刷新驗證碼</a>
              </div>
            </div>
            <div id="${ElIDWaveCacptchaKey}" style="display:none">${this.clientKey}</div>
            <div id="${ElIDWaveCaptchaRetryUrl}" style="display:none"></div>
          </div>
        `;

      // Attach the refreshCaptcha function to the click event
      document.getElementById(ElIDResetCaptcha)!.addEventListener('click', refreshCaptcha);
    }
  }

